<!-- Sized to the rail so the rail/content boundary runs unbroken from the top
     of the window, and everything after it starts on the content side. -->
<div class="brand" [class.collapsed]="nav.railCollapsed()">
	<!-- A panel toggle rather than a hamburger: this collapses a rail that stays
	     on screen, it does not open a menu.
	     first_page / last_page are used because this application loads the legacy
	     Material Icons font, where the panel glyphs (left_panel_close and
	     friends) do not exist and would render as their own names. These two are
	     in the font — the table paginators draw them. -->
	<button
		mat-icon-button
		class="rail-toggle"
		(click)="toggleRail()"
		[attr.aria-label]="nav.railCollapsed() ? 'Expand navigation' : 'Collapse navigation'"
		[attr.aria-expanded]="!nav.railCollapsed()"
	>
		<mat-icon>{{ nav.railCollapsed() ? "last_page" : "first_page" }}</mat-icon>
	</button>

	@if (!nav.railCollapsed()) {
		<a routerLink="/overview" class="logo">
			<img src="logo.png" alt="Matchie" />
		</a>
	}
</div>

<!-- Only shown once there is a hierarchy to climb. On a top-level page the
     trail is a single item that just repeats the page's own heading, so it is
     noise; from two levels down it is the way back up. -->
<nav class="crumbs" aria-label="Breadcrumb">
	@for (
		crumb of breadcrumbs.crumbs().length > 1 ? breadcrumbs.crumbs() : [];
		track crumb.url;
		let last = $last
	) {
		<span class="crumb">
			@if (last) {
				<span class="current" aria-current="page">{{ crumb.label }}</span>
			} @else {
				<a [routerLink]="crumb.url">{{ crumb.label }}</a>
				<mat-icon class="sep">chevron_right</mat-icon>
			}
		</span>
	}
</nav>

<span class="spacer"></span>

<mch-command-palette></mch-command-palette>

<button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu" aria-label="Account">
	<div class="avatar">
		@if ((user$ | async)?.photo_url) {
			<img [src]="(user$ | async)?.photo_url" alt="" (error)="onImageError($event)" />
		} @else {
			<mat-icon>account_circle</mat-icon>
		}
	</div>
</button>

<mat-menu #userMenu="matMenu">
	@if (user$ | async; as user) {
		<!-- No rule under the email: it reads as a heading for the items below,
		     not as a section apart from them. -->
		<div class="user-info">
			<p class="email">{{ user.email }}</p>
		</div>
	}
	<a mat-menu-item routerLink="/profile">
		<mat-icon>person</mat-icon>
		<span>Profile</span>
	</a>
	<mat-divider></mat-divider>
	<button mat-menu-item (click)="logout()">
		<mat-icon>logout</mat-icon>
		<span>Logout</span>
	</button>
</mat-menu>
